import { useFormikContext } from "formik";
import * as QuestionType from "../QuestionType";
import {
  DateConstraints,
  DateConstraintsSwitch,
  DateFormat,
} from "./DateConstraints";
import {
  NumberConstraints,
  NumberConstraintsSwitch,
  NumberFormat,
} from "./NumberConstraints";

export type QuestionConstraintsProps = {
  questionId: uuid;
};

type FormikType = QuestionType.FormikType;

export const QuestionFormat: React.FC<QuestionConstraintsProps> = ({
  questionId,
}) => {
  const formik = useFormikContext<FormikType>();

  switch (formik.values.type) {
    case "Date":
      return <DateFormat questionId={questionId} />;
    case "Number":
      return <NumberFormat questionId={questionId} />;
    default:
      return null;
  }
};

export const QuestionConstraints: React.FC<QuestionConstraintsProps> = ({
  questionId,
}) => {
  const formik = useFormikContext<FormikType>();

  switch (formik.values.type) {
    case "Date":
      return <DateConstraints questionId={questionId} />;
    case "Number":
      return <NumberConstraints questionId={questionId} />;
    default:
      return null;
  }
};

export const QuestionConstraintsSwitch: React.FC<QuestionConstraintsProps> = ({
  questionId,
}) => {
  const formik = useFormikContext<FormikType>();

  switch (formik.values.type) {
    case "Date":
      return <DateConstraintsSwitch questionId={questionId} />;
    case "Number":
      return <NumberConstraintsSwitch questionId={questionId} />;
    default:
      return null;
  }
};
